import { gql, useQuery } from "@apollo/client"
import { offsetLimitPagination } from "@apollo/client/utilities"
import { WORKFLOW_SUMMARY_FRAGMENT } from "./fragments/workflowSummaryFragment"

const GET_WORKFLOWS_QUERY = gql`
  query Workflows($filter: WorkflowFilterInput, $offset: Int, $limit: Int, $orderBy: WorkflowOrderByInput) {
    workflows {
      list(filter: $filter, limit: $limit, offset: $offset, orderBy: $orderBy) {
        ...WorkflowFields
      }
      count(filter: $filter)
    }
  }
  ${WORKFLOW_SUMMARY_FRAGMENT}
`

const COUNT_WORKFLOWS_QUERY = gql`
  query CountWorkflows($filter: WorkflowFilterInput) {
    workflows {
      count(filter: $filter)
    }
  }
`

const workflowsTypePolicies = {
  scoped: {
    WorkflowsQuery: {
      fields: {
        list: offsetLimitPagination(["filter"]),
        count: {
          keyArgs: ["filter"]
        }
      }
    }
  }
}

/**
 * @description A hook for fetching workflows.
 * @param {object} options - Options to pass to the useQuery hook.
 * @returns {Array} The result of the useQuery hook.
 */
const useQueryWorkflows = (options) => useQuery(GET_WORKFLOWS_QUERY, options)

const useQueryCountWorkflows = (options) => useQuery(COUNT_WORKFLOWS_QUERY, options)

export { useQueryWorkflows, GET_WORKFLOWS_QUERY, useQueryCountWorkflows, workflowsTypePolicies }
